import React from "react";
import Hero from "@/components/Hero";
import TwoArms from "@/components/TwoArms";
import { GolfNote } from "@/components/GolfNote";
import { GOLF_PARTNERSHIP_LIVE } from "@/config";

export default function Home() {
  return (
    <>
      <Hero />
      <TwoArms />
      {GOLF_PARTNERSHIP_LIVE && <GolfNote />}
    </>
  );
}
